module.exports = __webpack_public_path__ + "img/ico-close-dark.27052762.svg";